module.exports = __webpack_public_path__ + "img/Lifegiver2.9e00e769.png";